module.exports = __webpack_public_path__ + "static/meteor-maze-6s-1-76df71e6fc70646afee22d2842b91d88.png";